import ReactModal, { Styles } from 'react-modal';
import React from 'react';

import { WarningModalContainerProps } from 'containers/modals/WarningModalContainer/types';
import { SuccessModalContainerProps } from 'containers/modals/SuccessModalContainer/types';

export enum ModalName {
  FEE_ALERT = 'feeAlert',
  FEE_PAYMENT = 'feePayment',
  SPECIAL_OFFER = 'specialOffer',
  RETURN_OFFER = 'returnOffer',
  FEEDBACK_FORM = 'feedbackForm',
  ALERT_MODAL = 'alertModal',
  REASON_MODAL = 'reasonModal',
  REMINDER_MODAL = 'reminderModal',
  PAUSE_MODAL = 'pauseModal',
  FREE_MONTH_MODAL = 'freeMonthModal',
  FREEZE_ALERT_MODAL = 'freezeAlertModal',
  FREEZE_REASON_MODAL = 'freezeReasonModal',
  FREEZE_PERIOD_MODAL = 'freezePeriodModal',
  FREEZE_NOT_AVAILABLE_MODAL = 'freezeNotAvailableModal',
  REMINDER_HAS_BEEN_SET_MODAL = 'reminderHasBeenSet',
  SUCCESS_MODAL = 'successModal',
  WARNING_MODAL = 'warningModal',
  WAITING_MODAL = 'waitingModal',
  ERROR_MODAL = 'errorModal',
  DELETE_ACCOUNT = 'deleteAccount',
  DELETE_ACCOUNT_SUCCESS = 'deleteAccountSuccess',
  DELETE_ACCOUNT_ERROR = 'deleteAccountError',
}

export type ModalsType = {
  [ModalName.FEE_ALERT]: () => React.ReactNode | null;
  [ModalName.FEE_PAYMENT]: () => React.ReactNode | null;
  [ModalName.SPECIAL_OFFER]: ({ onError }: { onError?: () => void }) => React.ReactNode | null;
  [ModalName.RETURN_OFFER]: () => React.ReactNode | null;
  [ModalName.FEEDBACK_FORM]: () => React.ReactNode | null;
  [ModalName.ALERT_MODAL]: () => React.ReactNode | null;
  [ModalName.REASON_MODAL]: () => React.ReactNode | null;
  [ModalName.REMINDER_MODAL]: () => React.ReactNode | null;
  [ModalName.PAUSE_MODAL]: () => React.ReactNode | null;
  [ModalName.FREE_MONTH_MODAL]: () => React.ReactNode | null;
  [ModalName.WAITING_MODAL]: () => React.ReactNode   | null;
  [ModalName.FREEZE_ALERT_MODAL]: () => React.ReactNode | null;
  [ModalName.FREEZE_REASON_MODAL]: () => React.ReactNode | null;
  [ModalName.FREEZE_PERIOD_MODAL]: () => React.ReactNode | null;
  [ModalName.FREEZE_NOT_AVAILABLE_MODAL]: () => React.ReactNode | null;
  [ModalName.REMINDER_HAS_BEEN_SET_MODAL]: () => React.ReactNode | null;
  [ModalName.SUCCESS_MODAL]: (props: SuccessModalContainerProps) => React.ReactNode | null;
  [ModalName.WARNING_MODAL]: (props: WarningModalContainerProps) => React.ReactNode | null;
  [ModalName.ERROR_MODAL]: ({ tryAgain }: { tryAgain: () => void }) => React.ReactNode | null;
  [ModalName.DELETE_ACCOUNT]: () => React.ReactNode | null;
  [ModalName.DELETE_ACCOUNT_SUCCESS]: () => React.ReactNode | null;
  [ModalName.DELETE_ACCOUNT_ERROR]: () => React.ReactNode | null;
};

export type CommonModalProps = ReactModal.Props & { onClose?: () => void; closeOnOverlayClick?: boolean };

export interface IModal extends CommonModalProps {
  children: React.ReactNode;
  withCloseButton?: boolean;
  fullscreen?: boolean;
  dataLocator?: string;
  customStyles?: Styles;
  closeBtnLocator?: string;
}

export interface IAlertModal extends Omit<CommonModalProps, 'isOpen'> {
  onSubmit?: () => void;
  onDiscard?: () => void;
  onFreezeSubscription?: () => void;
  captions: {
    title: React.ReactNode;
    description: React.ReactNode;
    submitButton?: string;
    discardButton?: string;
    freezeButton?: string;
  };
  dataLocator?: string;
  isFreezeSubscription?: boolean;
  withoutIcon?: boolean;
}

export interface ICancellationReasonModal extends Omit<CommonModalProps, 'isOpen'> {
  onSubmit: (reason: string) => void;
  onCancel: () => void;
  onClose: () => void;
  isFreezeSubscription?: boolean;
}

export interface IFreezePeriodModal extends Omit<CommonModalProps, 'isOpen'> {
  onSubmit: (reason: string) => void;
  onDiscard: () => void;
  onClose: () => void;
}

export interface IWaitingModal extends Omit<CommonModalProps, 'isOpen'> {
  captions: { title?: string; subtitle?: string };
  dataLocator?: string;
}
